export default "__VITE_ASSET__6f2d222d__"